import React, { Suspense } from 'react'

const LandingMarketing = React.lazy(() => import('./LandingMarketing'))

export default function LandingPageMarketing() {
  return (
    <div>
      <Suspense fallback={<div>Loading...</div>}>
        <LandingMarketing />
      </Suspense>
    </div>
  )
}
